const verification_code = {
    phone_email_empty: '전화번호와 이메일이 모두 비어 있어요.',
    not_found: '인증 코드를 찾을 수 없어요. 인증 코드를 먼저 요청하세요.',
    phone_mismatch: '전화번호가 맞지 않아요. 새 인증 코드를 요청해 주세요.',
    email_mismatch: '이메일이 맞지 않아요. 새 인증 코드를 요청해 주세요.',
    code_mismatch: '인증 코드가 일치하지 않아요.',
    expired: '인증 코드가 만료되었어요. 새 인증 코드를 요청해 주세요.',
    exceed_max_try: '인증 코드 재시도 한도에 도달했어요. 새 인증 코드를 요청해 주세요.',
};
export default Object.freeze(verification_code);
